export enum eNotificationType {
    SUCCESS,
    ERROR,
    INFORMATION
}
